import { Entity } from "@common/types/entity";
import { createTransactionsUrl } from "@components/transactions/lib/transactionsUrl";
import { Menu } from "@design-system/Menu/Menu.lib";
import React from "react";
import { CaptureClicks } from "@design-system/CaptureClicks/CaptureClicks";
import { EntitySettingsPages } from "../settings/constants";
import { getEntityPaneKey } from "../settings/lib";
import { useSettings } from "../settings/SettingsProvider";

interface Props {
    entity: Entity;
}

export const EntityManagementDropdown: React.FC<Props> = ({ entity }) => {
    const { open } = useSettings();

    return (
        <CaptureClicks>
            <Menu.More>
                <Menu.LinkItem
                    to={createTransactionsUrl({ entityIds: [entity.id] })}
                >
                    Transactions
                </Menu.LinkItem>
                {!entity.isMockEntity && (
                    <Menu.Item
                        onClick={() =>
                            open([
                                getEntityPaneKey(
                                    EntitySettingsPages.SETTINGS,
                                    entity.id,
                                ),
                            ])
                        }
                    >
                        Settings
                    </Menu.Item>
                )}
            </Menu.More>
        </CaptureClicks>
    );
};
